import type { Season } from '@/modules/Content/interface/Content';
import type { FC } from 'react';
import {
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { CardHorizontalContentItem } from '@/components/modules/CardHorizontalContentItem';
import { MapRender } from '@/utils/jsx';

export const ClassesSection: FC<ClassesSectionProps> = ({ seasons }) => {
  return (
    <Tabs display="flex" flexDir="column" variant="solid-rounded" gap="l">
      <TabList w="fit-content">
        {seasons?.map(({ title }) => (
          <Tab key={title}>{title}</Tab>
        ))}
      </TabList>
      <TabPanels>
        {seasons?.map(({ title, contents }) => (
          <TabPanel key={title} p="0">
            <Flex
              flexDir="column"
              w="full"
              p="l"
              gap="l"
              bg="background.brandLight"
            >
              <MapRender
                items={contents}
                render={({ id, slug, title, view_time }) => (
                  <CardHorizontalContentItem
                    key={id}
                    href={`${PATHS.hubs.content}/${slug}`}
                    title={title}
                    duration={view_time || ''}
                    progress={0}
                  />
                )}
              />
            </Flex>
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

type ClassesSectionProps = {
  seasons: Season[];
};
